import {ArcTimeLineValidationTypes} from '../../util/uiconstants';

export default (state, response) => {
	const hasPic = response.some(
		({validationSubGroupId}) => validationSubGroupId === ArcTimeLineValidationTypes.PersonInCharge
	);

	return {
		...state,
		personInCharge: {
			checklistId: ArcTimeLineValidationTypes.PersonInCharge,
			isChecked: !hasPic,
			isDisabled: false,
			statusId: null
		}
	};
};
